(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/search"],{

/***/ "./src/assets/js/search.js":
/*!*********************************!*\
  !*** ./src/assets/js/search.js ***!
  \*********************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomSearch = /*#__PURE__*/function (_HTMLElement) {
  function CustomSearch() {
    var _this;
    _classCallCheck(this, CustomSearch);
    _this = _callSuper(this, CustomSearch);
    _this.openSearchBar = _this.openSearchBar.bind(_this);
    _this.closeSearchBar = _this.closeSearchBar.bind(_this);
    _this.fetchSearchResult = _this.fetchSearchResult.bind(_this);
    _this.fetchSearchResult = _this.debounce(_this.fetchSearchResult.bind(_this), 300);
    _this.handleSearchInput = _this.handleSearchInput.bind(_this);
    return _this;
  }
  _inherits(CustomSearch, _HTMLElement);
  return _createClass(CustomSearch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeElements();
      this.setEventListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListeners();
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      this.searchInput = this.querySelector('.custom-search__input') || null;
      this.body = document.querySelector('body') || null;
      this.header = document.querySelector('header') || null;
      this.searchIcon = this.header ? this.header.querySelector('.search-header') : null;
      this.closeIcon = this.querySelector('.custom-search__close-icon') || null;
      this.searchWrapper = this.querySelector('.custom-search__wrapper') || null;
      this.searchOverlay = this.querySelector('.custom-search__overlay') || null;
      this.defaultSearch = this.querySelector('.custom-search__default-state') || null;
      this.productBlock = this.querySelector('.custom-search__products-default') || null;
      this.productResultsContainer = this.querySelector('.custom-search__products-result') || null;
      this.blogPostBlock = this.querySelector('.custom-search__articles-default') || null;
      this.blogPostResultsContainer = this.querySelector('.custom-search__articles-result') || null;
      this.searchInfoBlock = this.querySelector('.custom-search__inner-wrapper') || null;
      this.nothingFound = this.querySelector('.custom-search__nothing-found') || null;
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      this.searchIcon.addEventListener('click', this.openSearchBar);
      this.closeIcon.addEventListener('click', this.closeSearchBar);
      this.searchOverlay.addEventListener('click', this.closeSearchBar);
      this.searchInput.addEventListener('input', this.handleSearchInput);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.searchIcon.removeEventListener('click', this.openSearchBar);
      this.closeIcon.removeEventListener('click', this.closeSearchBar);
      this.searchOverlay.removeEventListener('click', this.closeSearchBar);
      this.searchInput.addEventListener('input', this.handleSearchInput);
    }
  }, {
    key: "openSearchBar",
    value: function openSearchBar(event) {
      event.preventDefault();
      this.body.style.overflow = 'hidden';
      if (this.searchWrapper) {
        this.searchWrapper.classList.toggle('tw-hidden');
        this.searchWrapper.classList.toggle('tw-block');
      }
      if (this.searchOverlay) {
        this.searchOverlay.classList.toggle('tw-hidden');
        this.searchOverlay.classList.toggle('tw-block');
      }
      this.searchInput.focus();
    }
  }, {
    key: "closeSearchBar",
    value: function closeSearchBar() {
      this.body.style.overflow = 'auto';
      if (this.searchWrapper) {
        this.searchWrapper.classList.toggle('tw-hidden');
        this.searchWrapper.classList.toggle('tw-block');
      }
      if (this.searchOverlay) {
        this.searchOverlay.classList.toggle('tw-hidden');
        this.searchOverlay.classList.toggle('tw-block');
      }
    }
  }, {
    key: "handleSearchInput",
    value: function handleSearchInput() {
      var queryString = this.searchInput.value.trim();
      if (queryString.length === 0) {
        this.resetToDefaultView();
      } else {
        this.fetchSearchResult();
      }
    }
  }, {
    key: "fetchSearchResult",
    value: function fetchSearchResult() {
      var _this2 = this;
      var queryString = this.searchInput.value.trim();
      var resourceTypes = ['product', 'article'];
      var searchObj = {
        'q': queryString,
        'resources[limit]': 8,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[type]': resourceTypes.join(',')
      };
      if (queryString.length > 0) {
        var params = this.paramUrl(searchObj);
        var url = "".concat(theme.routes.predictiveSearch, "?").concat(params, "&section_id=search-results");
        console.log(url, 'url');
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (html) {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          var productResults = tempDiv.querySelectorAll('.results--products li');
          var blogResult = tempDiv.querySelectorAll('.results__group-1 .results--articles li');
          _this2.clearSearchResults(_this2.productResultsContainer, 'product-result-item');
          _this2.clearSearchResults(_this2.blogPostResultsContainer, 'article-result-item');
          _this2.defaultSearch.classList.add('!tw-hidden');
          var hasResults = false;
          if (productResults.length > 0) {
            hasResults = true;
            _this2.productBlock.classList.add('!tw-hidden');
            _this2.productResultsContainer.classList.remove('!tw-hidden');
            productResults.forEach(function (result) {
              var productLink = result.querySelector('a');
              var productTitle = result.querySelector('.results-products__title');
              var productType = result.querySelector('.results-products__type');
              var productPrice = result.querySelector('.grid-product__price');
              var productSubscriptionText = result.querySelector('.grid-product__subscription_text');
              var productImageSrc = result.querySelector('img').getAttribute('src');
              var productResultElement = document.createElement('div');
              productResultElement.classList.add('product-result-item');
              productResultElement.innerHTML = "\n                            <a class=\"custom-search__products-link\" href=\"".concat(productLink, "\">\n                                <div class=\"custom-search__products-image\">\n                                    ").concat(productImageSrc ? "<img src=\"".concat(productImageSrc, "\">") : '', "\n                                </div>\n                                <div>\n                                <div>\n                                    <h5 class=\"custom-search__products-details__title\">").concat(productTitle ? productTitle.textContent : '', "</h5>\n                                    <p class=\"custom-search__products-details__subtitle paragraph-p1\">").concat(productType ? productType.textContent : '', "</p>\n                                </div>\n                                <p class=\"custom-search__products-details__price header-h5\">\n                                <span class=\"tw-text-[14px] tw-font-normal\">").concat(productSubscriptionText ? productSubscriptionText.textContent : '', "</span>\n                                ").concat(productPrice ? productPrice.textContent : '', "\n                                </p>\n                                </div>\n                            </a>\n                            ");
              _this2.productResultsContainer.appendChild(productResultElement);
            });
          } else {
            _this2.productResultsContainer.classList.add('!tw-hidden');
          }
          if (blogResult.length > 0) {
            hasResults = true;
            _this2.blogPostBlock.classList.add('!tw-hidden');
            _this2.blogPostResultsContainer.classList.remove('!tw-hidden');
            blogResult.forEach(function (result) {
              var blogLink = result.querySelector('a');
              var blogTitle = result.querySelector('span');
              var blogResultElement = document.createElement('div');
              blogResultElement.classList.add('article-result-item');
              blogResultElement.innerHTML = "\n                  <a class=\"custom-search__articles-link header-h6\" href=\"".concat(blogLink ? blogLink.getAttribute('href') : '#', "\">\n                    ").concat(blogTitle ? blogTitle.textContent : '', "\n                  </a>\n                ");
              _this2.blogPostResultsContainer.appendChild(blogResultElement);
            });
          } else {
            _this2.blogPostResultsContainer.classList.add('!tw-hidden');
          }
          if (!hasResults) {
            _this2.nothingFound.classList.remove('tw-hidden');
            _this2.searchInfoBlock.classList.add('tw-hidden');
          } else {
            _this2.nothingFound.classList.add('tw-hidden');
            _this2.searchInfoBlock.classList.remove('tw-hidden');
          }
        })["catch"](function (error) {
          console.error('Error fetching search results:', error);
        });
      }
    }
  }, {
    key: "resetToDefaultView",
    value: function resetToDefaultView() {
      this.defaultSearch.classList.remove('!tw-hidden');
      this.productBlock.classList.remove('!tw-hidden');
      this.blogPostBlock.classList.remove('!tw-hidden');
      this.productResultsContainer.classList.add('!tw-hidden');
      this.blogPostResultsContainer.classList.add('!tw-hidden');
      this.nothingFound.classList.add('tw-hidden');
      this.searchInfoBlock.classList.remove('tw-hidden');
      this.clearSearchResults(this.productResultsContainer, 'product-result-item');
      this.clearSearchResults(this.blogPostResultsContainer, 'article-result-item');
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait) {
      var timeout;
      return function executedFunction() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          clearTimeout(timeout);
          func.apply(void 0, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }, {
    key: "clearSearchResults",
    value: function clearSearchResults(container, itemClass) {
      if (container) {
        var items = container.querySelectorAll(".".concat(itemClass));
        items.forEach(function (item) {
          return item.remove();
        });
      }
    }
  }, {
    key: "paramUrl",
    value: function paramUrl(obj) {
      return Object.keys(obj).map(function (key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('custom-search', CustomSearch);

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/search.js"));
/******/ }
]);